<div class="curtain">

<section class="component-modalDialog redesigned">

    <header>
        {{title}}
        <a class="closeModalDialog fa fa-close" (click)="closeModal()"></a>
    </header>

    <div class="contentContainer">
        <div class="col-6" *ngIf="message">
            <p class="message">
                {{message}}
            </p>
        </div>
        <div>
            <div class="col-6">
                <label for="input-text-dialog-input" class="entry-label">{{label}}</label>
                <input
                    [(ngModel)]="text"
                    type="text"
                    id="input-text-dialog-input"
                    placeholder="{{label}}"
                    maxlength="{{maxLength}}"
                    required
                    autofocus />
            </div>
            <div class="floatClearer"></div>
        </div>
    </div>

    <footer>
        <a class="button-primary" (click)="closeModal(text)">{{okButtonTitle}}</a>
        <a class="button-secondary" (click)="closeModal()">zavřít</a>
    </footer>

</section>

</div><!-- curtain -->